export const getProperty = state =>
  state.app.property && state.app.property.data ? state.app.property.data.attributes : null;
